import Layout from "@/layouts/default.vue";

export default [
    {
        path: "/document",
        name: "document",
        component: Layout,
        redirect: "/document/common",
        meta: {
            title: "文档中心",
            icon: "document-mng",
            permission: "manage_common_document",
        },
        children: [
            {
                path: "common",
                name: "document-manage",
                component: () => import("@/views/document/index.vue"),
                meta: {
                    title: "通用文档",
                    icon: "document",
                    app: "common",
                },
            },
            {
                path: "edit/:id?",
                name: "document-edit",
                component: () => import("@/views/document/edit.vue"),
                hidden: true,
                meta: {
                    title: "文档内容",
                    icon: "document",
                    activeMenu: "/document/common",
                },
            },
        ],
    },
];
